import { memo } from 'react';
import { GradientProgressBarItemStyled, GradientProgressBarStyled } from './styled/GradientProgressBarStyled';
import { ValueOf } from '../../../types';
import { GRADIENT_PROGRESS_BAR_DIRECTION_NAMES } from '../constants';
import _ from 'lodash';
import classNames from 'classnames';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';

interface GradientProgressBarProps {
    activeCount: number;
    count: number;
    direction?: ValueOf<typeof GRADIENT_PROGRESS_BAR_DIRECTION_NAMES>;
    messageCount?: number;
}

function GradientProgressBar(props: GradientProgressBarProps) {
    const { direction = GRADIENT_PROGRESS_BAR_DIRECTION_NAMES.NORMAL, count, activeCount, messageCount = activeCount } = props;
    const { getLangPath } = useLangContext();

    if (count === 0) return null;

    return <GradientProgressBarStyled
        className={classNames({ reversed: direction === GRADIENT_PROGRESS_BAR_DIRECTION_NAMES.REVERSE })}>
        {
            _.times(count, (index) => <GradientProgressBarItemStyled key={index}
                                                                   className={classNames({
                                                                       active: index <= activeCount - 1,
                                                                   })}/>)
        }
        <div className={'message'}>{getLangPath('demo_limits.free_trades_left', { amount: String(messageCount) })}</div>
    </GradientProgressBarStyled>;
}

export default memo(GradientProgressBar);
